// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".listing-cards-size-toggle{display:flex;flex-shrink:0}.listing-cards-size-toggle__button{color:#c6c6c6;display:flex;height:18px;transition:color .1s;width:18px}.listing-cards-size-toggle__button--active{color:var(--color-darkest)}.listing-cards-size-toggle__button:not(:last-child){margin:0 var(--spacing-smaller) 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
